import React from 'react';
import { Link } from 'react-router-dom';

type Props = {
  basePath: string,
  linkId: string,
  linkName: string
};

const ParentCampaignLink = (props: Props) => (
  <Link to={`${props.basePath}/${props.linkId}`}>{props.linkName}</Link>
);

export default ParentCampaignLink;



// WEBPACK FOOTER //
// ./src/views/Common/Partials/Helpers/ParentCampaignLink.tsx